import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Ul = styled.ul`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  padding-top: 10px;
  z-index: 100;

  li {
    font-weight: 800;
    font-size: 20px;
    padding: 10px 20px;
    background-color: #393b44;
    border-radius: 5px;
    cursor: pointer;
    margin: 0 15px;
  }

  @media (max-width: 768px) {
    display: flex;
    // justify-content: space-around;
    flex-flow: column nowrap;
    background-color: #1b262c;
    align-items: center;
    position: fixed;
    transform: ${({ open }) => (open ? 'translateX(0)' : 'translateX(100%)')};
    top: 0;
    right: 0;
    height: 100vh;
    width: 75%;
    padding-top: 3.5rem;
    transition: transform 0.3s ease-in-out;

    li {
      margin: 5px 0;
      width: 250px;
      background-color: none;
    }
  }
`;

const RightNav = ({ open }) => {
  return (
    <Ul open={open}>
      <Link to='/map-quiz'>
        <li>MapQuiz</li>
      </Link>
      <Link to='/leaderboards/'>
        <li>Leaderboards</li>
      </Link>
      <Link to='/about/'>
        <li>About</li>
      </Link>
    </Ul>
  );
};

export default RightNav;
